export const COMPANY = {
  name: "ANAS ENTERPRISES",
  tagline: "Civil Interior Contractor",
  gst: "27KARPS8682D1ZO",
  phone1: "+91 9867439947",
  phone2: "+91 7977988876",
  phone1Raw: "+919867439947",
  phone2Raw: "+917977988876",
  whatsapp: "https://wa.me/919867439947?text=Hello%20Anas%20Enterprises%2C%20I%20need%20a%20quote%20for%20marble%2Fgranite%20work%20in%20Mumbai.",
  email: "anasenterprises82@gmail.com",
  address: "Ground Floor D3, Room No 8, Basu Wala Soc, Kokniapada, Opp Triveni Nagar, Malad (East), Mumbai, India 400097",
  base: "Malad East, Mumbai 400097",
};

export const SERVICES = [
  { name: "Italian Marble Polish", desc: "Mirror finish floor buffing and high-grade crystallization for Botticino, Statuario, and imported slabs.", spec: "Diamond Pad Stages 400 to 3000", tag: "Italian Diamond Polish", img: "https://customer-assets-lxgj4vgw.emergentagent.net/job_anas-marble/artifacts/06f0a894289caf59_WhatsApp%20Image%202026-10-25%20at%2003.13.31.jpeg",
    extraImgs: [
      "https://customer-assets-lxgj4vgw.emergentagent.net/job_anas-marble/artifacts/b1ccc6ebd4de3190_WhatsApp%20Image%202026-10-25%20at%2014.04.52.jpeg",
      "https://customer-assets-lxgj4vgw.emergentagent.net/job_anas-marble/artifacts/40348bab120e4371_WhatsApp%20Image%202026-10-25%20at%2014.05.59.jpeg",
    ] },
  { name: "Granite Polish", desc: "Deep lustre restoration, scratch removal, and edge chamfering on Black Galaxy, Jet Black, and Tan Brown.", spec: "High Gloss Hard Seal", tag: "Granite Deep Buff", img: "https://images.pexels.com/photos/8142459/pexels-photo-8142459.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940" },
  { name: "Special Crack & Hairline Removal", desc: "Custom colour-matched epoxy resin filling, leveling uneven broken slabs, and invisible joint fusion.", spec: "Zero Joint Crack Lock", tag: "Crack Filling", img: "https://images.pexels.com/photos/12956025/pexels-photo-12956025.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940" },
  { name: "Marble Wall Polish & Buffing", desc: "Vertical marble wall shine, bathroom cladding rejuvenation, and anti-watermark protective sealing.", spec: "Hydrophobic Surface Barrier", tag: "Wall & Cladding", img: "https://images.pexels.com/photos/8142047/pexels-photo-8142047.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940" },
  { name: "Tiles & Marble Fixing Work", desc: "Master civil contractor services: laser level tile laying, tiles fitting, marble cutting, grouting, and full slab fixing.", spec: "Laser-Level Alignment", tag: "Fitting & Fixing", img: "https://images.pexels.com/photos/9690090/pexels-photo-9690090.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940" },
  { name: "Tiles Acid Wash & Stain Removal", desc: "Hard water scale removal, rust discoloration extraction, and deep chemical marble coating.", spec: "Neutralizing Nano Sealer", tag: "Stain Clean", img: "https://images.pexels.com/photos/39821905/pexels-photo-39821905.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940" },
];

export const FULL_SCOPE = [
  "Italian Marble Polish",
  "Granite Polish",
  "Italian Diamond Polish",
  "Marble Floor Polish",
  "Italian Marble Crystallization",
  "Marble Wall Polish",
  "Marble Buffing",
  "Tiles Acid Wash",
  "Tiles Marble Granite Fixing Work",
  "Marble Chemical Coating",
  "Marble Cutting & Fitting",
  "Marble Floor Rectification",
  "Flooring Stain Removal & Crack Hairline Removal",
];

export const GALLERY_JOBS = [
  {
    tag: "FLOOR RESTORATION",
    place: "Stain & Damage Removal",
    title: "Damaged Floor to Mirror Finish",
    desc: "Deep grinding, patch repair and multi-stage polish on a badly worn marble floor.",
    img: "https://customer-assets-lxgj4vgw.emergentagent.net/job_anas-marble/artifacts/010307dec6aa3e4e_WhatsApp%20Image%202026-10-22%20at%2019.45.46.jpeg",
  },
  {
    tag: "MARBLE POLISH",
    place: "Italian Technique",
    title: "Dull Marble to High Gloss",
    desc: "Full diamond pad polish with Italian crystallization for a mirror-like surface.",
    img: "https://customer-assets-lxgj4vgw.emergentagent.net/job_anas-marble/artifacts/20f1cdab33b90dc1_WhatsApp%20Image%202026-10-25%20at%2013.42.30.jpeg",
  },
  {
    tag: "CRACK FILLING",
    place: "Special Crack Repair",
    title: "Hairline Crack & Patch Fusion",
    desc: "Colour-matched epoxy filling on cracked and patched marble, leveled flush.",
    img: "https://customer-assets-lxgj4vgw.emergentagent.net/job_anas-marble/artifacts/f0703ceaefd4a912_WhatsApp%20Image%202026-10-25%20at%2013.41.25.jpeg",
  },
  {
    tag: "SURFACE POLISH",
    place: "Wall & Floor Panels",
    title: "Stained Surface Revival",
    desc: "Chemical treatment and buffing that removes deep stains and yellowing.",
    img: "https://customer-assets-lxgj4vgw.emergentagent.net/job_anas-marble/artifacts/90130c50dd594d4f_WhatsApp%20Image%202026-10-25%20at%2013.37.13.jpeg",
  },
  {
    tag: "FLOOR GRINDING",
    place: "Rough to Glossy",
    title: "Rough Floor to Reflective Gloss",
    desc: "Heavy grinding followed by fine polishing for a smooth, light-reflecting floor.",
    img: "https://customer-assets-lxgj4vgw.emergentagent.net/job_anas-marble/artifacts/1c888b1734b28479_WhatsApp%20Image%202026-10-25%20at%2013.46.43.jpeg",
  },
];

export const HERO_IMG = "https://images.pexels.com/photos/6987720/pexels-photo-6987720.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";
